import React from "react";

import { DiaryTabs } from "../DiaryTabs/DiaryTabs";

export type DiaryTabsWrapperProps = {
  selectedSectionKey: string;
  diarySections: any;
};

export const DiaryTabsWrapper = ({
  selectedSectionKey,
  diarySections
}: DiaryTabsWrapperProps) => {
  return (
    <DiaryTabs
      selectedSectionKey={selectedSectionKey}
      sections={diarySections}
    />
  );
};
